import { createContext } from "react";

export const AnimatePhaseContext = createContext<"enter" | "exit">("enter");
